export default __webpack_public_path__ + "static/media/Maplun.9b95d7ac.svg";